export default "__VITE_ASSET__igPkkK7U__"